// ─────────────────────────────────────────────────────────────────────────────
// 照片数据入口。
//
// 原版 meow 用 webpack 的 require.context 在「构建期」把 src/assets/ 里的照片
// 全量打进网站——产物路径会带上内容哈希（2026-05-11.1024×768.85bd8e02….webp），
// 图片一改链接就变，blog.xhja.cn 没法长期引用。
//
// 这里改成「清单驱动」：照片本体放在 public/photos/<分类>/，
// 清单由 `python scripts/build-albums.py` 生成到 src/data/albums.json。
// 于是路径稳定：https://pics.xhja.cn/photos/travel/2026-05-11_01.webp
// ─────────────────────────────────────────────────────────────────────────────

// 照片清单（脚本生成，不要手改）
import albumsData from './data/albums.json'
// 图片地址前缀 + 隐藏分类判断
import { isHiddenCategory, resolveImageUrl } from './config/albums.config'

interface AlbumPhoto {
  category: string
  date: string
  width: number
  height: number
  file: string
  size?: number
  title?: string
  desc?: string
}

// 打包进来的原始清单。
// 站长后台（/admin）首屏直接用它渲染 —— 清单本来就会随构建打进产物，
// 没必要为了"显示照片列表"再跑一趟 GitHub（那要好几秒）。
// API 返回的数据只用来核对/纠正（比如刚上传、站点还没重建时）。
// ⚠️ 这里刻意**不做隐藏分类过滤**：后台要能看到、能管理图床位的照片。
export const ALBUM_MANIFEST: AlbumPhoto[] = (albumsData.photos as AlbumPhoto[])
  .filter((photo) => !!photo && !!photo.file)

// 首页画册的数据。隐藏分类（图床位，如「隐藏」）在这里被剔除 ——
// 那些照片照常部署、直链可用，只是不进首页画廊。
export const GALLERY_DATA: Pic[] = ALBUM_MANIFEST
  .filter((photo) => photo.width > 0 && photo.height > 0)
  .filter((photo) => !isHiddenCategory(photo.category))
  .map((photo) => ({
    category: photo.category,
    date: photo.date,
    width: photo.width,
    height: photo.height,
    aspectRatio: photo.width / photo.height,
    title: photo.title,
    desc: photo.desc,
    path: resolveImageUrl(photo.file),
  }))
